import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import styles from './styles';
import LoadsTab from './LoadsTabV2';
import LoadFactorTab from './LoadFactorTab';
import PF2MTabs from '~/components/PF2MTabs';
import { setAlertDialog } from '~/store/manager/actions';

const Codes = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();
  const isLoadFactorsDirty = useSelector(state => state.manager.isLoadFactorsDirty);
  const dispatch = useDispatch();
  const tabs = [
    { key: 0, label: translate('common:AverageLoad') },
    { key: 1, label: translate('common:LoadFactor') },
  ];

  const handleChange = (event, value) => {
    let blockChange = false;

    switch (value) {
      case 0:
        blockChange = isLoadFactorsDirty;
        break;
      default:
        blockChange = false;
        break;
    }

    if (blockChange) {
      event.preventDefault();
      dispatch(setAlertDialog());
    } else {
      setSelectedTab(value);
    }
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<LoadsTab />) : null}
      {selectedTab === 1 ? (<LoadFactorTab />) : null}
    </>
  );
};

export default withStyles(styles)(Codes);
